import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postUnmarkProjectAsInactive = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}projects/markfinished/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

export default postUnmarkProjectAsInactive;
